import type { ElementTweenFunction } from '../types';
import { gsap } from 'gsap';
import { setMetaTagColor } from '../../setColorMetaTag';

export const setMetaToM23Green: ElementTweenFunction = () => {
    const interpolator = gsap.utils.interpolate("#000", "#0F0");
    let progress = 0; // Track progress manually

    const tween = gsap.to({ progress: 0 }, {
        progress: 1, // Animate from 0 to 1
        duration: .84,
        onUpdate: function () {
            progress = this.progress(); // Use GSAP's `this.progress()` to get the current progress
            const currentColor = interpolator(progress);
            setMetaTagColor(currentColor);
        }
    });

    return { tween, position: ">" }; // Return the tween and its position
};
